export type AllowedContentWidth = 'default' | 'full';

export function isAllowedContentWidth(contentWidth: string): contentWidth is AllowedContentWidth {
  return contentWidth === 'full' || contentWidth === 'default';
}
